import { useMutation, useQueryClient } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';
import { approvalQueueKeys } from './useApprovalQueue';
import { leaveKeys } from './useMijnVerlof';

/**
 * Story 2.6: een urencorrectie beoordelen (goedkeuren/afwijzen), naar het
 * model van `useDecideLeaveRequest`.
 *
 * Drie caches raken hierdoor verouderd, en alle drie worden ze ververst:
 * - de goedkeuringslijst zelf (de rij verdwijnt na het besluit);
 * - het eigen verlofoverzicht van de indiener (de geldende uren en de
 *   correctiestatus staan daar);
 * - de aanwezigheidskalender — een goedgekeurde correctie werkt de uren IN
 *   PLACE bij (AD-10), dus het teamoverzicht toont anders nog het oude
 *   tijdvak van een collega.
 */
export function useDecideLeaveCorrection() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      decision,
      reason,
    }: {
      id: number;
      decision: 'approve' | 'reject';
      reason?: string;
    }) => verlofApi.decideCorrection(id, decision, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: approvalQueueKeys.all });
      queryClient.invalidateQueries({ queryKey: leaveKeys.all });
      queryClient.invalidateQueries({ queryKey: ['aanwezigheidskalender'] });
    },
  });
}
